import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import Tooltip from '@mui/material/Tooltip'
import Network from '../general/Network'

type BadgeProps = {
  timelock: any
  className?: string
  children: React.ReactNode
}

export function CalendarItem({ timelock, className, children }: BadgeProps) {
  const allowedAt = moment.unix(Number(timelock.timelock.allowedAt)).utc()

  const tooltipContent = (
    <TooltipContent>
      <TooltipTitle>Timelock</TooltipTitle>
      <TooltipRow><TooltipLabel>Task</TooltipLabel><TooltipValue>{timelock.task}</TooltipValue></TooltipRow>
      <TooltipRow><TooltipLabel>Chain</TooltipLabel><TooltipValue>{timelock.chainId}</TooltipValue></TooltipRow>
      <TooltipRow><TooltipLabel>Client</TooltipLabel><TooltipValue>{timelock.environment}</TooltipValue></TooltipRow>
      <TooltipRow>
        <TooltipLabel>Allowed at</TooltipLabel>
        <TooltipValue>{allowedAt.format('MMM D, YYYY HH:mm [UTC]')}</TooltipValue>
      </TooltipRow>
    </TooltipContent>
  )

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      <Badge className={className}>
        <BadgeTop>
          <BadgeTime>{allowedAt.format('HH:mm')}</BadgeTime>
          <Network network={timelock.chainId} small />
        </BadgeTop>
        <BadgeName>{timelock.task}</BadgeName>
      </Badge>
    </Tooltip>
  )
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const Badge = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 5px 7px;
  border-radius: 5px;
  background: rgba(111,92,230,0.14);
  border: 1px solid rgba(111,92,230,0.28);
  cursor: default;
  transition: background 0.15s, border-color 0.15s;

  &:hover {
    background: rgba(111,92,230,0.22);
    border-color: rgba(111,92,230,0.45);
  }
`

const BadgeTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
`

const BadgeTime = styled.span`
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 9px;
  color: #a89aff;
  flex-shrink: 0;
`

const BadgeName = styled.span`
  font-size: 10px;
  color: #c4bcff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
`

const TooltipContent = styled.div`
  padding: 4px 2px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const TooltipTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #ededed;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`

const TooltipRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: baseline;
`

const TooltipLabel = styled.span`
  font-size: 10px;
  color: #777;
  min-width: 56px;
  flex-shrink: 0;
`

const TooltipValue = styled.span`
  font-size: 11px;
  color: #a0a0a0;
  word-break: break-all;
`
